import { ICopyable } from '../core/copyable.interface';
import { IPredefinedEmail } from './interface/predefined-email.interface';

export class EmailTemplate implements ICopyable<EmailTemplate> {
    id: number;
    name: string;
    template: IPredefinedEmail;

    public createCopy(): EmailTemplate {
        const instance = new EmailTemplate();
        instance.id = this.id;
        instance.name = this.name;
        instance.template = this.template;

        return instance;
    }

    public copyFrom(other: any) {
        this.id = other.id;
        this.name = other.name;
        this.template = other.template;
    }
}
